<div class="filter-tournament-situation">
    <button
        *ngFor="let filterTOption of filterTournamentSituationOptions"
        [class.active]="filterTournamentSituation === filterTOption.filter"
        (click)="changeFilter(filterTOption)"
    >
        {{ filterTOption.label }}
    </button>
</div>
